import React from "react";
import { useTimeFilter } from "../contexts/TimeFilterContext";

function formatRange(dateRange) {
  const [start, end] = dateRange;
  return `${start.format("D MMM YYYY")} – ${end.format("D MMM YYYY")}`;
}

export default function HistoricalBanner() {
  const { mode, dateRange, returnToLive } = useTimeFilter();

  if (mode === "live" || !dateRange) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-between rounded-xl border border-amber-300 bg-amber-50 px-4 py-2 text-sm dark:border-amber-700 dark:bg-amber-900/20"
    >
      <span className="text-amber-800 dark:text-amber-300">
        <span aria-hidden="true">📅 </span>
        Viewing data from <strong>{formatRange(dateRange)}</strong> · Not live
      </span>
      <button
        onClick={returnToLive}
        className="ml-4 shrink-0 rounded-lg border border-amber-400 bg-white px-3 py-1 text-xs font-medium text-amber-700 transition-colors hover:bg-amber-50 dark:border-amber-600 dark:bg-navy-800 dark:text-amber-300 dark:hover:bg-amber-900/30"
      >
        Return to live
      </button>
    </div>
  );
}
